import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueBreadcrumbs from 'vue-breadcrumbs'
Vue.use(VueBreadcrumbs);
Vue.config.productionTip = false
Vue.prototype.$url = 'https://agoffice.gov.mv/api'
Vue.use(VueAxios, axios)
Vue.use(require('vue-moment'))
// Vue.prototype.$activeTab = 'Home'
new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
